<template>
  <div class="contractpayment">
        <div class="contractpayment__title">
            <h1>Доставка и оплата</h1>
        </div>
        <div class="contractpayment_margin">
            <h3>
                 График работы Интернет - магазина:
            </h3>
            <ul>
                <li>С Понедельника по Пятницу с 10:00 до 18:00</li>
                <li>Суббота и Воскресенье - доставки нет.</li>
            </ul>
            <h3>
                Доставка по городу Актобе:
            </h3>
            <ul>
                <li>Доставка интернет-магазина осуществляется в будние дни с 14:00 до 18:00.</li>
                <li>При заказе продукции до 13:00 доставка осуществляется День-в-День, после 13:00 доставка осуществляется на следующий день.</li>
                <li>Суббота и Воскресенье - выходные дни и Ваш заказ будет доставлен в понедельник.</li>
                <li>При заказе на сумму до 25.000 тенге стоимость доставки  - 500 тенге.</li>
                <li>Стоимость доставки в указанное Вами время - 1.000 тенге (во временном интервале с 14.00 до 18.00).</li>
                <li>Заказы на сумму более 25.000 тенге доставляются Бесплатно ( в пределах границ доставки г. Актобе ( см. карту))</li>
            </ul>
            <h3>
                Доставка по области и другим городам: 
            </h3>
            <h3>
                Доставка осуществляется Казпочтой либо выбранной клиентом ТК. Сроки доставки зависят от сроков доставки ТК
            </h3>
            <h3>
                Средний срок доставки 7-14 дней
            </h3>
        </div>  
  </div>
</template>

<script>
export default {
  name: 'contractpayment',
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.contractpayment {
    width: 1200px;
    margin: 0 auto;
    background: white;
    @media (max-width: @baseMedia) {
        width: 95%;
    }
    .contractpayment__title {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        @media (max-width: @baseMedia) {
            padding-top: 10px;
            padding-bottom: 10px;
        }
        h1 {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 20px;
            }
        }
    }
    .contractpayment_margin {
        width: 95%;
        margin: 0 auto;
        padding-bottom: 20px;

        h3 {
            margin-bottom: 10px;
            font-size: 22px;
            color: #4a4a4a;
            @media (max-width: @baseMedia) {
                font-size: 18px;
            }
        } 
        ul {
            margin-bottom: 10px;
            font-size: 18px;
            margin-left: 20px;
            @media (max-width: @baseMedia) {
                font-size: 15px;
            }
            color: #4a4a4a;
        }
    }
}
</style>